import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import { RoutePaths } from '../../constants/routes';
import styles from './Login.module.scss';
import { Alert, Button, CredentialsPageContainer, Input, Text } from 'components';
import { appActions } from 'store/app/slice';
import { authActions } from 'store/auth/slice';
import { useDispatch } from 'store/utils';

const schema = yup.object({
  email: yup.string().required('The field is empty').email('The text is not an email'),
  password: yup.string().required('The field is empty'),
});

export const Login = () => {
  const [errorMessage, setErrorMessage] = useState('');

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const emailWatch = watch('email');
  const passwordWatch = watch('password');

  useEffect(() => {
    if (errorMessage) {
      setErrorMessage('');
    }
  }, [emailWatch, passwordWatch]);

  const dispatch = useDispatch();

  const onSubmit = handleSubmit(async (data) => {
    try {
      dispatch(appActions.setAppIsLoading(true));
      await dispatch(authActions.signIn({ username: data.email, password: data.password })).unwrap();
    } catch (error: any) {
      setErrorMessage(error?.message);
    } finally {
      dispatch(appActions.setAppIsLoading(false));
    }
  });

  return (
    <CredentialsPageContainer formTitle="Log in" formSubtitle="Please, enter your credentials">
      <form className={styles.formContainer}>
        <div className={styles.formContent}>
          <Input
            inputName="email"
            labelText="Email"
            placeholder="Enter your email"
            errorMsg={errors.email?.message}
            register={register}
            registerOptions={{ required: true }}
            showContacts
          />
          <div className={styles.passwordInputContainer}>
            <Input
              inputName="password"
              labelText="Password"
              placeholder="Enter your password"
              errorMsg={errors.password?.message}
              register={register}
              registerOptions={{ required: true }}
              canBeHidden
            />
            <Link className={styles.forgotPasswordLink} to={RoutePaths.FORGOT_PASSWORD}>
              <Text type="body2">Forgot password?</Text>
            </Link>
          </div>
          {errorMessage && (
            <Alert type="error">
              <Text type="body2">{errorMessage}</Text>
            </Alert>
          )}
        </div>
        <Button onClick={onSubmit} className={styles.loginButton}>
          Log in
        </Button>
      </form>
    </CredentialsPageContainer>
  );
};
